// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".stream-card[data-v-517869c4]{border-radius:15px!important;max-width:300px;overflow:hidden}.stream-card[data-v-517869c4]:not(.cursor-pointer){cursor:inherit}.live[data-v-517869c4]{background:#d32f2f;border-radius:5px}.companylist[data-v-517869c4]{overflow:hidden;text-overflow:ellipsis}.disabled[data-v-517869c4]{pointer-events:none}.list-wrapper[data-v-517869c4]{border-radius:0!important;height:3em;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
